import { useEffect, useState } from 'react';

interface UseScrollArrowsProps {
  tabsRef: React.RefObject<HTMLUListElement>;
}

const useScrollArrows = ({ tabsRef }: UseScrollArrowsProps) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const tabTitlesContainer = tabsRef.current;
  const scrollPadding = 60;

  const scrollTabs = (direction: 'left' | 'right') => {
    const tabTitlesContainer = tabsRef.current;
    if (tabTitlesContainer) {
      const tabList = tabTitlesContainer;
      const tabElements = tabList.querySelectorAll('.tab-title');
      let newScrollPosition = tabTitlesContainer.scrollLeft;
      const containerRightEdge =
        tabTitlesContainer.scrollLeft + tabTitlesContainer.offsetWidth;
      if (direction === 'left') {
        for (let i = tabElements.length - 1; i >= 0; i--) {
          const tabElement = tabElements[i] as HTMLElement;
          if (tabElement.offsetLeft < tabTitlesContainer.scrollLeft) {
            newScrollPosition = tabElement.offsetLeft - scrollPadding;
            break;
          }
        }
      } else {
        for (let i = 0; i < tabElements.length; i++) {
          const tabElement = tabElements[i] as HTMLElement;
          if (
            tabElement.offsetLeft + tabElement.offsetWidth >
            containerRightEdge
          ) {
            newScrollPosition =
              tabElement.offsetLeft +
              tabElement.offsetWidth -
              tabTitlesContainer.offsetWidth +
              scrollPadding;
            break;
          }
        }
      }

      tabTitlesContainer.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth',
      });
    } else {
      console.error('.tabbed-block-tabs-list element not found');
      return;
    }
  };

  const scrollArrows = (container: HTMLUListElement) => {
    if (container) {
      setShowLeftArrow(container.scrollLeft > 0);
      setShowRightArrow(
        container.scrollLeft < container.scrollWidth - container.offsetWidth
      );
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      scrollArrows(tabTitlesContainer!);
    };

    if (tabTitlesContainer) {
      tabTitlesContainer.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleScroll);
      scrollArrows(tabTitlesContainer);
    }

    return () => {
      if (tabTitlesContainer) {
        tabTitlesContainer.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleScroll);
      }
    };
  }, [tabTitlesContainer]);

  return { showLeftArrow, showRightArrow, scrollTabs };
};

export default useScrollArrows;
